import TR from 'utils/TR';
import Header from 'components/header';
import T from 'utils/T';
import ex from 'utils/ex';
import GlocoseSummary from './GlocoseSummary';
import GlocosePattern from './GlocosePattern';
import GlocoseHighList from './GlocoseHighList';
import GlocoseLowList from './GlocoseLowList';
import GlocoseAnalysis from './GlocoseAnalysis';
import GlocoseProfile from '../../../charts/GlocoseProfileChart';
import GlocoseAbnormals from './GlocoseAbnormals';
import VBox from 'components/common/VBox';
import Division from 'components/common/Division';
import Segment from 'components/common/Segment';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import GuideButton from '../GuideButton';
import PageContent from 'components/pages/PageContent';
import PageTitle from 'components/pages/PageTitle';
import ReportTabs from '../ReportTabs';

import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

import useReportBloodSugar from 'hooks/communication/useReportBloodSugar';
import './ReportBloodGlocose.css';
import Section from 'components/common/Section';
import GlocoseProfileChart from '../../../charts/GlocoseProfileChart';
import { useSignal } from 'modules/Signals';

export default function ReportBloodGlocose(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const {
    requestReportBloodSugar,
  } = useReportBloodSugar();

  const signal = useSignal();
  const [data, setData] = Recoil.useRecoilState(AppStore.assets.data('ReportBloodGlocose'));
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    requestReportBloodSugar({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
    }, (success, data) => {
      if (success) {
        setData(() => data);
      } else {
        setData(() => ({}));
      }
    })
  }, [patient_no, period_end, period_start, requestReportBloodSugar, setData]);

  React.useEffect(() => {
    if (!front) return;
    signal('ReportData', data, 'ReportBloodGlocose');
  }, [front, data, signal]);

  const duration = renderAll ? 0 : 1;
  return (
    <div {...ex(['Page', 'ReportBloodGlocose'], rest)}>
      <PageContent>
        <VBox full>
          <Division>
            <GlocoseSummary {...{ data }} />
          </Division>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <Section
              {...ex('GlocoseProfile', rest)}
              {...{
                caption: T('혈당개요 (AGP)'),
                direction: DIRECTION_VERTICAL,
              }}
            >
              <GlocoseProfileChart {...{ duration }} />
            </Section>
            <GlocoseAnalysis  {...{ data, duration }} />
          </Segment>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <GlocoseAbnormals  {...{ data, duration }} />
            <GlocoseHighList {...rest} {...{duration}} />
            <GlocoseLowList {...rest} {...{duration}} />
          </Segment>
          <Segment>
            <GlocosePattern  {...{ data, duration }} />
          </Segment>
        </VBox>
      </PageContent>
    </div >
  );
}
